'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// UI lib components
import { Group } from '@mantine/core';
import { IconMessageQuestion } from '@tabler/icons-react';

// UI local components

// Types
import { MatchQuestionItemProps } from './types';

// Style
import * as classes from './styles/index.css';
import { Link } from 'react-router-dom';
import Highlight from '@app/shared/ui-kit/atoms/Highlight';
import useWorkspace from '@app/features/Workspace/store/hooks/useWorkspace';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
function MatchQuestionItem({
  question,
  query = '',
  onClick,
}: MatchQuestionItemProps) {
  const workspace = useWorkspace();
  /* ******************************** RENDERING ******************************* */
  return (
    <Link
      className={classes.link}
      to={`/workspace/${workspace.id}/support?questionId=${question.id}`}
      onClick={onClick}
    >
      <Group gap={6} wrap="nowrap" w="100%">
        <IconMessageQuestion size={18} />
        <Highlight highlight={query} truncate fz="sm" style={{ flex: 1 }}>
          {question.title!}
        </Highlight>
      </Group>
    </Link>
  );
}

export default MatchQuestionItem;
